(function () {
  'use strict';

  autocomplete.$inject = ["PATH"];
  app.directive('autocomplete', autocomplete);

  function autocomplete(PATH) {
    return {
      controller: 'AutocompleteController',
      restrict: 'E',
      templateUrl: PATH.components + 'autocomplete/autocomplete.tpl.html'
    };
  }

  app.controller('AutocompleteController', ['$scope', '$http', function ($scope, $http) {
    $scope.locations = [];

    $scope.getLocations = function () {
      var searchText = $scope.searchText;
      var apiKey = 'pFAjma4olsMApCHhbRTbN1djpkAWGiev';

      if (searchText && searchText.length >= 3) {
        var apiUrl = 'https://api.tomtom.com/search/2/search/' + encodeURIComponent(searchText) + '.json?key=' + apiKey + '&countrySet=US';

        $http.get(apiUrl, { withCredentials: false })
          .then(function (response) {
            $scope.locations = response.data.results;
          })
          .catch(function (error) {
            console.log('Error:', error);
          });
      } else {
        $scope.locations = [];
      }
    };
    $scope.setLocation = function (location) {
      $scope.searchText = location.address.freeformAddress;
      $scope.locations = [];
    };

    $('body').on('keydown', function (e) {
      if (e.keyCode === 38 || e.keyCode === 40) { // Up arrow
        var currentElement = document.activeElement;
        var dropdownMenuMaps = $('.dropdown-menu--maps')[0];
        var listItems = dropdownMenuMaps ? dropdownMenuMaps.getElementsByTagName('li') : null;
        var currentItemIndex = Array.prototype.indexOf.call(listItems, currentElement);

        if (e.keyCode === 38) { // Up arrow
          e.preventDefault();
          if (currentItemIndex > 0) {
            listItems[currentItemIndex - 1].focus();
          }
        } else if (e.keyCode === 40) { // Down arrow
          e.preventDefault();
          if (currentItemIndex < listItems.length - 1) {
            listItems[currentItemIndex + 1].focus();
          }
        }
      }
    });
  }]);
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/autocomplete/autocomplete.js